export interface AdvertiserConfig {
  buyer: string
  did: string | null
  url?: string
}

export const advertiserMapping: Record<string, AdvertiserConfig> = {
  '2': {
    buyer: 'JG Wentworth',
    url: 'jgwentworth',
    did: '1-888-421-6993',
  },
  '3': {
    buyer: 'Freedom Debt',
    url: 'freedom',
    did: '1-888-247-6313',
  },
  '4': {
    buyer: 'ClearOne Advantage',
    url: 'clearone',
    did: '1-888-246-1312',
  },
  '9': {
    buyer: 'Century Support Services',
    url: 'century',
    did: null,
  },
  '16': {
    buyer: 'NOLO Attorney Network',
    url: 'nolo',
    did: null,
  },
  '19': {
    buyer: 'Accredited Debt Relief',
    url: 'adr',
    did: '1-888-421-6991',
  },
  '20': {
    buyer: 'Credit Associates',
    url: 'creditassociates',
    did: '1-888-458-8159',
  },
  '21': {
    buyer: 'National Debt Relief',
    url: 'ndr',
    did: '1-866-633-2108',
  },
  '22': {
    buyer: 'Skyline Financials',
    url: 'skyline',
    did: null,
  },
  '23': {
    buyer: 'Renew Debt Relief',
    url: 'renew',
    did: '1-855-719-9019',
  },
  '24': {
    buyer: 'ARC Advantage',
    url: 'arc',
    did: '1-888-499-8862',
  },
  '30': {
    buyer: 'ARC Advantage',
    url: 'arc',
    did: '1-877-496-6363',
  },
  '28': {
    buyer: 'Pacific Debt Relief',
    url: 'pacificdebt',
    did: '1-833-865-2028',
  },
  '101': {
    buyer: 'Debt Blue',
    url: 'debtblue',
    did: '1-888-888-8888',
  },
  '26': {
    buyer: 'Better Finances',
    url: 'logo',
    did: null,
  },
}

export function getAdvertiser(advertiserId: string | undefined): AdvertiserConfig | null {
  if (!advertiserId) return null
  return advertiserMapping[advertiserId] || null
}
